export function shouldSkipPhoneNumberProcessing (){

    //check if its localized
    const wbId = (document.getElementById("weblocationId") as HTMLInputElement | null)?.value || (document.getElementById("local_weblocationId") as HTMLInputElement | null)?.value || null;
    const isLocal = (wbId) || localStorage.getItem('dbaName');

    //check if this is for JUK as only JUK has a diff phone number format with 88**JUK
    const conceptId = (document.getElementById("conceptId") as HTMLInputElement | null)?.value ?? null;

    //return true if its not localized and its for JUK
    if(!isLocal && conceptId === '30'){
        return true
    }   
    return false
}